var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * Promise-based replacement for setTimeout / clearTimeout.
 */
var _require = require('./utils'),
    promiseFinally = _require.promiseFinally,
    toError = _require.toError;

module.exports = /*#__PURE__*/function () {
  "use strict";

  function Timeout() {
    _classCallCheck(this, Timeout);

    this._id = null;
    this._delay = null;
  }

  _createClass(Timeout, [{
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "delay",
    get: function get() {
      return this._delay;
    }
  }, {
    key: "set",
    value: function set(delay) {
      var _this = this;

      var rejectReason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return new Promise(function (resolve, reject) {
        _this.clear();

        var fn = rejectReason ? function () {
          return reject(toError(rejectReason));
        } : resolve;
        _this._id = setTimeout(fn, delay);
        _this._delay = delay;
      });
    }
  }, {
    key: "wrap",
    value: function wrap(promise, delay) {
      var _this2 = this;

      var rejectReason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var wrappedPromise = promiseFinally(promise, function () {
        return _this2.clear();
      });
      var timer = this.set(delay, rejectReason);
      return Promise.race([wrappedPromise, timer]);
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this._id) {
        clearTimeout(this._id);
      }
    }
  }], [{
    key: "set",
    value: function set(delay, rejectReason) {
      return new Timeout().set(delay, rejectReason);
    }
  }, {
    key: "wrap",
    value: function wrap(promise, delay, rejectReason) {
      return new Timeout().wrap(promise, delay, rejectReason);
    }
  }]);

  return Timeout;
}();